export const AUTH_ROUTE_PATHS = {
  login: '/auth/login',
  loginCallback: '/auth/login/callback',
  loginFailed: '/auth/login/failed',
  logout: '/auth/logout',
};

export const AUTH_API_PATHS = {
  /** POST /panel/auth-init — resolves IDP by email, returns PKCE params. */
  authInit: '/auth-init',
  /** POST /panel/login — exchanges code+state for SESSION_TOKEN cookie. */
  login: '/login',
  logout: '/logout',
  me: '/me',
  /** POST /panel/refresh — refreshes the session-service session. */
  refresh: '/refresh',
} as const;

export default { RoutePaths: AUTH_ROUTE_PATHS };
